import React, { useRef, useState } from 'react'
import './FacilityDropdown.scss'
import { unfavoriteFacilityUpdate, favoriteFacilityUpdate } from '../../../helper/backendHelper'
import { useDispatch } from 'react-redux'
import { getFacilities } from '../../../redux/census/censusThunk'
import { useOutsideClick } from '../../../hooks/useOutsideClick'
import { getPOSDisplay } from '../shared/sharedFacilityLogic'

export default function FacilityDropdown({ options, selectedVal, handleChange, showStars }) {
  const dispatch = useDispatch()

  const [searchQuery, setSearchQuery] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const ref = useRef(null)
  useOutsideClick(ref, () => setIsOpen(false))

  const selectOption = (option) => {
    setSearchQuery('')
    handleChange(option)
    setIsOpen(false)
  }

  const getDisplayValue = () => {
    if (isOpen) {
      return searchQuery
    }
    if (selectedVal) {
      // spaces for the star icon
      return (showStars ? '     ' : '') + selectedVal.name + getPOSDisplay(selectedVal)
    }

    return ''
  }

  const filter = (options) => {
    if (!searchQuery) {
      return options
    }

    return options.filter(
      (option) => option.name.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1,
    )
  }

  const onClickStar = async (facility_id, isFavorite) => {
    if (isFavorite) {
      await unfavoriteFacilityUpdate(facility_id)
    } else {
      await favoriteFacilityUpdate(facility_id)
    }

    dispatch(getFacilities())
  }

  const displayFacility = (facility, showName = true) => {
    return (
      <>
        {showStars && (
          <>
            {facility?.favorite ? (
              <i
                className="fa-solid fa-star fav-icon"
                style={{ fontSize: '1em', cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation()
                  onClickStar(facility?._id, true)
                }}
              ></i>
            ) : (
              <i
                className="fa-regular fa-star"
                style={{ fontSize: '1em', cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation()
                  onClickStar(facility?._id, false)
                }}
              ></i>
            )}
            &nbsp; &nbsp;
          </>
        )}
        {showName ? facility?.name + getPOSDisplay(facility) : ''}
      </>
    )
  }

  return (
    <div className="searchable-dropdown" ref={ref}>
      <div className="control">
        <div
          className="selected-value"
          style={{
            position: 'relative',
          }}
        >
          {showStars && !isOpen && selectedVal && (
            <span
              style={{
                position: 'absolute',
                bottom: '7px',
                left: '8px',
              }}
            >
              {displayFacility(selectedVal, false)}
            </span>
          )}
          <input
            type="text"
            value={getDisplayValue()}
            name="searchTerm"
            onChange={(e) => {
              setSearchQuery(e.target.value)
            }}
            onClick={() => {
              setSearchQuery('')
              setIsOpen(true)
            }}
            autoComplete={'off'}
          />
        </div>
        <div className={`arrow ${isOpen ? 'open' : ''}`}></div>
      </div>

      {isOpen && (
        <div className={`options open`}>
          {filter(options).map((option) => {
            return (
              <div
                onClick={() => {
                  selectOption(option)
                }}
                className={`option ${option.name === selectedVal?.name ? 'selected' : ''}`}
                key={`dropdown-${option.name}-${option._id}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {displayFacility(option)}
              </div>
            )
          })}
          {filter(options)?.length === 0 && <div className={`option`}>No results found</div>}
        </div>
      )}
    </div>
  )
}
